import React from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';

const TabList = ({ tabs, onSelect, selectedTab }) => (
  <ul className="tabs--wrapper">
    {tabs.map((tab, index) => (
      <Tab
        selected={ selectedTab === tab.data }
        title={tab.title}
        className={tab.className}
        id={tab.id}
        onClick={(e) => onSelect(e, index, tab)}
        data={tab.data}
        key={`tabitem-${tab.id}`}
      />
    ))}
  </ul>
);

TabList.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      className: PropTypes.string,
      data: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
  onSelect: PropTypes.func,
  selectedTab: PropTypes.string
};
export default TabList;
